export default __webpack_public_path__ + "locales/ar-SA/InviteDialog.json?hash=7bd840e4e70c6c44c5452bc1c29dcafb";